import EyeToggleIcon from "../images/EyeToggleIcon.js";

export default function EyeToggleButton({ onClick, show }) {
  return (
    <button
      type="button"
      className="absolute right-3 top-3 text-gray-500"
      tabIndex={-1}
      onClick={() => onClick(!show)}
      aria-label={show ? "Şifreyi gizle" : "Şifreyi göster"}
    >
      <EyeToggleIcon show={show} />
    </button>
  );
}
